<template>
  <div>
    <vxe-grid
      ref="fieldsTable"
      class="sort-fields-popover"
      :show-header="false"
      :data="options"
      :columns="columns"
      :height="height"
      :empty-text="
        funcListName
          ? `功能【${funcListName}】无排序字段配置`
          : 'props:funcListName 无值'
      "
      :row-config="{ keyField: 'sortColName' }"
      row-id="sortColName"
      border="none"
      size="mini"
      @checkbox-change="checkboxChange"
    >
      <template #fields="{row}">
        <div class="row_fields-text" @click="checkboxChange({ row })">
          {{ row.sortColText }}
        </div>
        <div class="row_fields-opt" v-if="row.sortIndex">
          <span
            @click.stop
            class="row_fields-sortType"
            :class="row.sortType"
            @click="toggleSortType(row)"
          >
            <i class="el-icon-bottom" v-if="row.sortType === 'DESC'" />
            <i class="el-icon-top" v-if="row.sortType === 'ASC'" />
          </span>
          <span class="row_fields-sortIndex">
            {{ row.sortIndex }}
          </span>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
import { request } from '@/api/service'
export default {
  props: {
    value: { type: Array, required: true },
    funcListName: { type: String, required: true },
    height: { type: Number, default: 250 },
  },
  data() {
    return {
      options: [],
      defaultOptions: [],
      columns: [
        {
          field: 'checkbox',
          width: 40,
          align: 'center',
          type: 'checkbox',
        },
        {
          title: '字段',
          field: 'fields',
          minWidth: 70,
          headerAlign: 'left',
          align: 'left',
          slots: { default: 'fields' },
        },
      ],
      checkRows: [],
    }
  },
  computed: {
    checkRowKeys() {
      return this.checkRows.map(({ sortColName }) => sortColName)
    },
  },
  watch: {
    checkRows: {
      handler(val) {
        this.setTableCheckbox()
        this.setFieldsSortInfo()

        this.$emit('input', val)
        this.$emit('update:value', val)
      },
      deep: true,
    },
    value: {
      handler(val) {
        this.checkRows = val
      },
      deep: true,
    },
    funcListName: {
      handler() {
        this.init()
      },
    },
  },
  created() {
    this.init()
    this.checkRows = this.value
  },
  methods: {
    async init() {
      const data = (await this.getData()) || []
      this.options = data

      const defOptions = this.options
        .filter(({ sortIndex }) => !!sortIndex)
        .sort((a, b) => a.sortIndex - b.sortIndex)
      this.defaultOptions = JSON.parse(JSON.stringify(defOptions))
      setTimeout(() => {
        this.setDefCheckbox()
      }, 0)
    },
    async getData() {
      if (!this.funcListName) return
      const res = await request({
        url: '/sys/sort/column/set/dictSelect',
        method: 'POST',
        data: { funcListName: this.funcListName },
      }).catch(() => null)
      if (!res) return
      return res.body.data || []
    },
    checkboxChange({ row }) {
      const rowIndex = this.checkRows.findIndex(
        (r) => r.sortColName === row.sortColName
      )
      if (rowIndex >= 0) {
        this.checkRows.splice(rowIndex, 1)
      } else {
        this.checkRows.push(row)
      }

      this.$emit('change', this.checkRows)
    },
    setDefCheckbox() {
      this.checkRows = []
      if (!this.defaultOptions || !this.defaultOptions.length) {
        return
      }
      this.$emit('input', this.defaultOptions)
      this.$emit('update:value', this.defaultOptions)

      const defOptions = JSON.parse(JSON.stringify(this.defaultOptions))
      this.checkRows = defOptions
    },
    setTableCheckbox() {
      const $table = this.$refs.fieldsTable
      const tableData = $table.getTableData().fullData
      tableData.forEach((row) => {
        const { sortColName } = row
        const checked = this.checkRowKeys.includes(sortColName)
        $table.setCheckboxRow(row, checked)
      })
    },
    setFieldsSortInfo() {
      const $table = this.$refs.fieldsTable
      const tableData = $table.getTableData().fullData
      tableData.forEach((row) => {
        const { sortColName } = row
        const checkIndex = this.checkRowKeys.findIndex(
          (key) => sortColName === key
        )

        const sortIndex = checkIndex >= 0 ? checkIndex + 1 : 0
        row.sortIndex = sortIndex

        if (checkIndex >= 0) {
          const checkRow = this.checkRows[checkIndex]
          row.sortType = checkRow.sortType
        }
      })
    },
    toggleSortType(row) {
      row.sortType = row.sortType === 'DESC' ? 'ASC' : 'DESC'

      this.checkRows.forEach((r) => {
        if (r.sortColName === row.sortColName) {
          r.sortType = row.sortType
        }
      })

      this.$emit('change', this.checkRows)
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .vxe-table--render-default .vxe-table--empty-content {
    width: 100%;
  }
  .vxe-table--body {
    width: 100% !important;
    .vxe-body--row {
      .vxe-body--column {
        border-bottom: 1px solid #d9dddf;
        .vxe-cell {
          padding-right: 68px !important;
          position: relative;
        }
      }
      .vxe-body--column:last-child {
        .vxe-cell {
          padding-left: 0 !important;
        }
      }
      .row_fields-text {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
      }
      .row_fields-opt {
        position: absolute;
        top: 0;
        right: 3px;
        width: 65px;
        height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        align-items: center;
        span {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          border-radius: 50%;
          height: 20px;
          width: 20px;
          background: #238ff9;
          color: #ffffff;
        }
        span.row_fields-sortType.DESC {
          background: $color-warning !important;
          cursor: n-resize;
        }
        span.row_fields-sortType.ASC {
          background: $color-success !important;
          cursor: s-resize;
        }
      }
    }
    .vxe-body--row:last-child .vxe-body--column {
      border-bottom: none;
    }
  }
}
</style>
